import { authenticatedPatch } from './api_service';

const UserService = {
  updateUser: (data) => {
    return authenticatedPatch('/rest-auth/user/', data);
  }
}

export default UserService;
